import { useCallback } from "react";
import useWeb3 from "../useWeb3";
import environment from "../../utils/Environment";
import { getGemsTokenContract } from "../../utils/contractHelpers";

const ApproveGems = () => {
  const web3 = useWeb3();

  const approveGems = useCallback(
    async (account, amount, tokenAddress, decimals) => {
      console.log(amount, tokenAddress, decimals, 'approveGems');

      const contract = getGemsTokenContract(tokenAddress, web3);
      let nd = 19000000000000// '9999999999999999999999999';
      nd = web3.utils.toWei(nd.toString(), "ether");
      // console.log(nd, 'ndndndndndndndn');

      try {
        // const gas = await contract.methods
        //   .approve(environment.GemsSubscription, nd)
        //   .estimateGas({ from: account });

        const details = await contract.methods
          .approve(environment.GemsSubscription, nd)
          .send({
            from: account,
            // gas,
          });
        return details;
      } catch (error) {
        console.log("Error in approveGems:", error);
        throw error;
      }
    },
    [web3]
  );
  return { approveGems: approveGems };
};
export default ApproveGems;
